<template>
  <div class="profile cart">
    <div class="card profile-info full-height">
      <div class="card-body" v-if="currentUser?.membership_exists">
        <div class="tariff-header">
          <h4 class="tariff-title">Тариф</h4>
          <label class="tariff-label" :class="currentUser?.name_membership">
            {{ currentUser?.name_membership }}
          </label>
        </div>

        <p class="tariff-status">Активный</p>

        <p class="tariff-row">
          Доступ действует с:
          <span class="tariff-value">
            {{ formatDate(currentUser?.active_membership?.start_date) }}
          </span>
        </p>

        <p class="tariff-row">
          Доступ действует до:
          <span class="tariff-value">
            {{ formatDate(currentUser?.active_membership?.end_date) }}
          </span>
        </p>

        <p
          class="tariff-row"
          v-if="currentUser?.active_membership?.auto_payment"
        >
          Следующее списание:
          <span class="tariff-value">
            {{ formatDate(currentUser?.active_membership?.end_date) }}
          </span>
        </p>

        <div class="company-actions">
          <button
            class="black-button"
            v-if="currentUser?.active_membership?.auto_payment"
            @click="onCancelClick"
          >
            Отменить автоплатеж
          </button>
        </div>
      </div>
      <div v-else class="card-body">Нет действующих подписок</div>
    </div>
    <ConfirmationOfCancellationModal
      ref="confirmationOfCancellationModal"
      @confirm="cancelAutoPayment"
    />
  </div>
</template>

<script setup>
import { computed, ref, onMounted } from "vue";
import { useStore } from "vuex";
import moment from "moment";
import ConfirmationOfCancellationModal from "@/components/Modals/ConfirmationOfCancellationModal.vue";

const store = useStore();
const currentUser = computed(() => store.state.user.user);
const confirmationOfCancellationModal = ref(null);
const isLoading = ref(false);

const onCancelClick = () => {
  confirmationOfCancellationModal?.value?.openModal();
};

const formatDate = (date) => {
  return moment(date).format("DD.MM.YYYY");
};

const cancelAutoPayment = async () => {
  try {
    isLoading.value = true;
    await store.dispatch("payments/cancelAutoPayment");
    confirmationOfCancellationModal?.value?.closeModal?.();
    console.log("Автоплатёж успешно отменён");
  } catch (e) {
    console.error("Ошибка при отмене автоплатежа", e);
  } finally {
    isLoading.value = false;
  }
};
</script>

<style lang="scss" scoped>
@media (max-width: 820px) {
  .profile.cart {
    height: 212px;
    .card.profile-info.full-height {
      background: transparent;
      border: none;
      box-shadow: none;
      border-radius: 0;
      height: auto;
      padding: 0;
    }

    .card.profile-info.full-height > .card-body {
      padding: 0;
      height: 100px;
    }
  }
}

.tariff-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.tariff-title {
  font-size: 20px;
  font-weight: 700;
  color: #3e3e3e;
}

.tariff-label {
  border: none;
  padding: 5px 15px;
  border-radius: 100px;
  color: #ffffff;
  font-size: 20px;
  font-weight: 400;
  cursor: default;

  &.Free {
    background: linear-gradient(90deg, #00c782 0%, #00613f 100%);
  }

  &.Business {
    background: linear-gradient(90deg, #0099ff 0%, #005c99 100%);
  }

  &.Premium {
    background: linear-gradient(90deg, #d4af37 0%, #6e5b1d 100%);
  }
}

.tariff-status {
  font-size: 15px;
  font-weight: 400;
  color: #58b251;
}

.tariff-row {
  margin-top: -15px;
  font-size: 15px;
  font-weight: 400;
  color: #000000;
}

.tariff-value {
  font-weight: 700;
  font-size: 15px;
  margin-left: 5px;
}
</style>
